// Sport-dependent filter helpers — config comes from the shared /api/sports catalogue.
const norm = (s) =>
  String(s || "")
    .replace(/-/g, " ")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");

export function sportFilterConfig(sports, sportId) {
  if (!sportId || sportId === "__all__") return null;
  const s = (sports || []).find((x) => x.id === sportId);
  return s?.filter || null;
}

export function playerMatchesSport(player, sportId) {
  if (!sportId || sportId === "__all__") return true;
  return (player.sport || "football") === sportId; // legacy records = football
}

export function playerMatchesPosition(player, config, positionId) {
  if (!config || !positionId || positionId === "__all__") return true;
  const opt = config.options.find((o) => o.id === positionId);
  if (!opt) return true;
  const value = player[config.key] ?? player.sport_data?.[config.key] ?? "";
  const v = norm(value);
  return [norm(opt.label), ...(opt.match || []).map(norm)].includes(v);
}
